/**
 * @generated SignedSource<<ac35f34f448c342a6a45937eaafa3c9f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ecommerceTrackingProductData_item$data = {
  readonly address: {
    readonly englishCountryName: string | null;
  } | null;
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly displayPriceTracking: ReadonlyArray<{
    readonly amountType: string | null;
    readonly convertedAmountList: ReadonlyArray<{
      readonly amount: number | null;
      readonly currency: Currency | null;
    } | null> | null;
    readonly textType: string | null;
  } | null> | null;
  readonly isNewListing: boolean | null;
  readonly medianL3SoldItemPriceScore: number | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"shippingCostHelpers_item">;
  readonly " $fragmentType": "ecommerceTrackingProductData_item";
};
export type ecommerceTrackingProductData_item$key = {
  readonly " $data"?: ecommerceTrackingProductData_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ecommerceTrackingProductData_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ecommerceTrackingProductData_item"
};

(node as any).hash = "dc1a327096d93d205951c7eaf629d18b";

export default node;
